import React from 'react';
import { Link } from 'react-router-dom';
import './PublicidadSubNav.css';

export const PublicidadSubNav = ({ tab, setTab, isAdmin, showBackLink = false }) => {
  const item = (value, label) => <Link
    className={tab === value ? 'active' : ''}
    to={`/publicidad?tab=${value}`}
    onClick={() => setTab?.(value)}
  >{label}</Link>;

  return <nav className="publicidad-subnav-shell" aria-label="Secciones de publicidad">
    {showBackLink && <Link className="publicidad-back-link" to="/publicidad?tab=publicaciones">← Volver a publicidad</Link>}
    <div className="publicidad-subnav">
      {item('publicaciones', 'Publicaciones')}
      {item('descuentos', 'Descuentos')}
      {isAdmin && item('admin', 'Gestionar publicaciones')}
      {isAdmin && <Link className={tab === 'sponsor-admin' ? 'active' : ''} to="/admin/patrocinadores">Gestionar descuentos</Link>}
    </div>
  </nav>;
};
